import { render, staticRenderFns } from "./UserLogin.vue?vue&type=template&id=1cbafab6&scoped=true"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"
import style0 from "./UserLogin.vue?vue&type=style&index=0&id=1cbafab6&prod&lang=less&scoped=true"
import style1 from "./UserLogin.vue?vue&type=style&index=1&id=1cbafab6&prod&lang=less&scoped=true"
import style2 from "./UserLogin.vue?vue&type=style&index=2&id=1cbafab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbafab6",
  null
  
)

export default component.exports